import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import api from '../services/api';
import { useToast } from '../hooks/useToast';

const المحتوى = () => {
  const [activeContentTab, setActiveContentTab] = useState('المنشورات');
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { showToast } = useToast();

  const contentTabs = [
    { id: 'المنشورات', label: 'المنشورات', type: 'posts' },
    { id: 'الريلز', label: 'الريلز', type: 'reels' },
    { id: 'الستوري', label: 'الستوري', type: 'stories' },
  ];

  const getCurrentType = () => {
    const currentTab = contentTabs.find(tab => tab.id === activeContentTab);
    return currentTab ? currentTab.type : 'posts';
  };

  useEffect(() => {
    fetchContent();
  }, [activeContentTab, page]);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const type = getCurrentType();
      const response = await api.getContent(type, page, 24);
      
      if (response && response.items) {
        setContent(response.items);
        setTotalPages(Math.ceil((response.total || 0) / 24) || 1);
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      showToast('حدث خطأ في جلب المحتوى', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المحتوى؟')) {
      return;
    }

    try {
      const type = getCurrentType();
      if (type === 'posts') {
        await api.deletePost(id);
      } else if (type === 'stories') {
        await api.deleteStory(id);
      } else if (type === 'reels') {
        await api.deleteVideo(id);
      }
      showToast('تم حذف المحتوى بنجاح', 'success');
      fetchContent();
    } catch (error) {
      console.error('Error deleting content:', error);
      showToast('حدث خطأ في حذف المحتوى', 'error');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#2B2F3F',
      overflow: 'hidden',
      direction: 'rtl'
    }}>
      <Header />
      <div style={{ 
        flex: 1, 
        padding: '32px', 
        backgroundColor: '#2B2F3F', 
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        boxSizing: 'border-box'
      }}>
        {/* Title and Tabs */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '8px'
        }}>
          {/* Content Tabs - Left */}
          <div style={{ 
            display: 'flex', 
            flexDirection: 'row',
            gap: '12px'
          }}>
            {contentTabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => {
                  setActiveContentTab(tab.id);
                  setPage(1);
                }}
                style={{
                  padding: '10px 20px',
                  borderRadius: '12px',
                  border: activeContentTab !== tab.id ? '1px solid rgba(102, 106, 122, 0.22)' : 'none',
                  backgroundColor: activeContentTab === tab.id ? '#F27D72' : 'rgba(176, 179, 187, 0.13)',
                  color: activeContentTab === tab.id ? '#FFFFFF' : '#666A7A',
                  fontFamily: 'El Messiri, sans-serif',
                  fontSize: '14px',
                  fontWeight: activeContentTab === tab.id ? 700 : 500,
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  height: '42px',
                  boxSizing: 'border-box'
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Title - Right */}
          <h2 style={{ 
            fontFamily: 'El Messiri, sans-serif', 
            fontSize: '24px', 
            fontWeight: 700, 
            color: '#FFFFFF',
            margin: 0
          }}>
            المحتوى
          </h2>
        </div>

        {/* Content List */}
        <div style={{ 
          backgroundColor: '#FFFFFF', 
          borderRadius: '16px', 
          padding: '24px',
          border: '1px solid rgba(233, 106, 58, 0.15)',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.06)',
          flex: 1,
          overflow: 'auto',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {loading ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              padding: '40px',
              color: '#666A7A',
              fontFamily: 'Cairo, sans-serif'
            }}>
              جاري التحميل...
            </div>
          ) : content.length === 0 ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              padding: '40px',
              color: '#666A7A',
              fontFamily: 'Cairo, sans-serif'
            }}>
              لا يوجد محتوى
            </div>
          ) : (
            <>
              <table style={{ width: '100%', borderCollapse: 'collapse', direction: 'rtl' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid rgba(233, 106, 58, 0.1)' }}>
                    <th style={{ 
                      padding: '16px 12px', 
                      textAlign: 'right', 
                      fontFamily: 'El Messiri, sans-serif', 
                      fontSize: '14px', 
                      fontWeight: 700, 
                      color: '#2B2F3F' 
                    }}>المحتوى</th>
                    <th style={{ 
                      padding: '16px 12px', 
                      textAlign: 'right', 
                      fontFamily: 'El Messiri, sans-serif', 
                      fontSize: '14px', 
                      fontWeight: 700, 
                      color: '#2B2F3F' 
                    }}>المؤلف</th>
                    <th style={{ 
                      padding: '16px 12px', 
                      textAlign: 'right', 
                      fontFamily: 'El Messiri, sans-serif', 
                      fontSize: '14px', 
                      fontWeight: 700, 
                      color: '#2B2F3F' 
                    }}>التاريخ</th>
                    <th style={{ 
                      padding: '16px 12px', 
                      textAlign: 'right', 
                      fontFamily: 'El Messiri, sans-serif', 
                      fontSize: '14px', 
                      fontWeight: 700, 
                      color: '#2B2F3F' 
                    }}>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {content.map((item) => (
                    <tr key={item.id} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.06)' }}>
                      <td style={{ 
                        padding: '16px 12px', 
                        textAlign: 'right', 
                        fontFamily: 'Cairo, sans-serif', 
                        fontSize: '14px', 
                        color: '#2B2F3F',
                        fontWeight: 600
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', direction: 'rtl' }}>
                          {(item.thumbnailUrl || item.mediaUrl) && (
                            <img 
                              src={item.thumbnailUrl || item.mediaUrl} 
                              alt="content"
                              style={{
                                width: '60px',
                                height: '60px',
                                objectFit: 'cover',
                                borderRadius: '8px'
                              }}
                            />
                          )}
                          <span style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item.caption || item.text || 'بدون عنوان'}
                          </span>
                        </div>
                      </td>
                      <td style={{ 
                        padding: '16px 12px', 
                        textAlign: 'right', 
                        fontFamily: 'Cairo, sans-serif', 
                        fontSize: '14px', 
                        color: '#666A7A'
                      }}>
                        {item.owner?.name || '-'}
                      </td>
                      <td style={{ 
                        padding: '16px 12px', 
                        textAlign: 'right', 
                        fontFamily: 'Cairo, sans-serif', 
                        fontSize: '13px', 
                        color: '#666A7A'
                      }}>
                        {formatDate(item.createdAt)}
                      </td>
                      <td style={{ 
                        padding: '16px 12px', 
                        textAlign: 'right'
                      }}>
                        <div style={{ 
                          display: 'flex', 
                          gap: '8px', 
                          justifyContent: 'flex-start',
                          direction: 'rtl'
                        }}>
                          <button 
                            onClick={() => handleDelete(item.id)}
                            style={{
                              padding: '6px 16px',
                              borderRadius: '8px',
                              border: 'none',
                              backgroundColor: '#F27D72',
                              color: '#FFFFFF',
                              cursor: 'pointer',
                              fontFamily: 'Cairo, sans-serif',
                              fontSize: '12px',
                              fontWeight: 600
                            }}
                          >
                            حذف
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  gap: '8px',
                  marginTop: '24px',
                  paddingTop: '24px',
                  borderTop: '1px solid rgba(0, 0, 0, 0.06)'
                }}>
                  <button
                    onClick={() => setPage(p => Math.max(1, p - 1))}
                    disabled={page === 1}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: '1px solid rgba(102, 106, 122, 0.22)',
                      backgroundColor: page === 1 ? 'rgba(176, 179, 187, 0.13)' : '#FFFFFF',
                      color: page === 1 ? '#666A7A' : '#2B2F3F',
                      cursor: page === 1 ? 'not-allowed' : 'pointer',
                      fontFamily: 'Cairo, sans-serif',
                      fontSize: '14px',
                      fontWeight: 600
                    }}
                  >
                    السابق
                  </button>
                  <span style={{ 
                    fontFamily: 'Cairo, sans-serif', 
                    fontSize: '14px', 
                    color: '#666A7A',
                    padding: '0 16px'
                  }}>
                    صفحة {page} من {totalPages}
                  </span>
                  <button
                    onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                    disabled={page === totalPages}
                    style={{
                      padding: '8px 16px',
                      borderRadius: '8px',
                      border: '1px solid rgba(102, 106, 122, 0.22)',
                      backgroundColor: page === totalPages ? 'rgba(176, 179, 187, 0.13)' : '#FFFFFF',
                      color: page === totalPages ? '#666A7A' : '#2B2F3F',
                      cursor: page === totalPages ? 'not-allowed' : 'pointer',
                      fontFamily: 'Cairo, sans-serif',
                      fontSize: '14px',
                      fontWeight: 600
                    }}
                  >
                    التالي
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default المحتوى;
